import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import Profile from '../views/Profile.vue';
import Requests from '../views/Requests.vue';
import AdminUsers from '../views/AdminUsers.vue';
import Jobs from '../views/Jobs';
import Job from '../views/Job';
import Meetings from '../views/Meetings';
import Meeting from '../views/Meeting';
import Team from '../views/Team';
import Reports from '../views/Reports';
import Companies from '../views/Companies';
import Company from '../views/Company';
import Activities from '../views/Activities';
import AuthService from '../services/AuthService';
import User from '../views/User';
import MeetingNotes from '../views/MeetingNotes.vue';
import Candidate from '../views/Candidate.vue';
import Request from '../views/Request.vue';
import MegaFiles from '../views/MegaFiles.vue';
import Tasks from '../views/Tasks.vue';
import Task from '../views/Task.vue';
import TaskForm from '../views/TaskForm.vue';
import Sellers from '../views/Sellers.vue';
import Forms from '../views/Forms.vue';
import Send from '../views/Send.vue';
import Survey from '../views/Survey.vue';
import Thanks from '../views/Thanks.vue';
import SurveyInternalView from '../views/SurveyInternalView.vue';
import Pdi from '../views/Pdi.vue';
import Avaliation360 from '../views/Avaliation360.vue';
import Eventos from '../views/Eventos.vue';
import Evento from '../views/Evento.vue';
import TrainingTypes from '../views/TrainingTypes.vue';
import CertificateTemplates from '../views/CertificateTemplates.vue';
import EventRegister from '../views/EventRegister.vue';
import EventRegisterSuccess from '../views/EventRegisterSuccess.vue';
import CertificateValidation from '../views/CertificateValidation.vue';

const routes = [
  {
    path: '/',
    name: 'auth',
    component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/pdi',
    name: 'pdi',
    component: Pdi
  },
  {
    path: '/obrigado',
    name: 'thanks',
    component: Thanks
  },
  {
    path: '/envios/:form_uuid?',
    name: 'send',
    component: Send
  },
  {
    path: '/avaliacao-360',
    name: '360',
    component: Avaliation360
  },
  {
      path: '/megasurvey/form/:form_uuid',
      name: 'surveyByForm',
      component: Survey
  },
  {
      path: '/megasurvey/interno/dispatch/:dispatch_uuid',
      name: 'surveyinternal',
      component: SurveyInternalView
  },
  {
      path: '/megasurvey/dispatch/:dispatch_uuid',
      name: 'surveyByDispatch',
      component: Survey
  },
  {
    path: '/forms',
    name: 'forms',
    component: Forms
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/vendedores',
    name: 'sellers',
    component: Sellers
  },
  {
    path: '/cadastro-demanda-interna/:id_task?',
    name: 'taskform',
    component: TaskForm
  },
  {
    path: '/demandas-internas',
    name: 'tasks',
    component: Tasks
  },
  {
    path: '/demanda/:id',
    name: 'task',
    component: Task
  },
  {
    path: '/meu-perfil',
    name: 'my-profile',
    component: Profile
  },
  {
    path: '/perfil/:id?',
    name: 'profile',
    component: Profile
  },
  {
    path: '/candidato/:job_id/:id?',
    name: 'candidate',
    component: Candidate
  },
  {
    path: '/usuarios',
    name: 'users',
    component: AdminUsers
  },
  {
    path: '/solicitacoes',
    name: 'requests',
    component: Requests
  },
  {
    path: '/mega-arquivos',
    name: 'megafiles',
    component: MegaFiles
  },
  {
    path: '/solicitacao/:id',
    name: 'request',
    component: Request
  },
  {
    path: '/processos-seletivos',
    name: 'jobs',
    component: Jobs
  },
  {
    path: '/processo-seletivo/:id?',
    name: 'job',
    component: Job
  },
  {
    path: '/reunioes',
    name: 'meetings',
    component: Meetings
  },
  {
    path: '/reuniao/:id?',
    name: 'meeting',
    component: Meeting
  },
  {
    path: '/notes/:company_id?',
    name: 'notes',
    component: MeetingNotes
  },
  {
    path: '/clientes',
    name: 'companies',
    component: Companies
  },
  {
    path: '/usuario/:company_id/:user_id?',
    name: 'user',
    component: User
  },
  {
    path: '/cliente/:id?',
    name: 'company',
    component: Company
  },
  {
    path: '/relatorios',
    name: 'reports',
    component: Reports
  },
  {
    path: '/time',
    name: 'team',
    component: Team
  },
  {
    path: '/atividades',
    name: 'activities',
    component: Activities
  },
  {
    path: '/eventos',
    name: 'eventos',
    component: Eventos
  },
  {
    path: '/evento/:uuid?',
    name: 'evento',
    component: Evento
  },
  {
    path: '/tipos-treinamento',
    name: 'trainingTypes',
    component: TrainingTypes
  },
  {
    path: '/modelos-certificado',
    name: 'certificateTemplates',
    component: CertificateTemplates
  },
  {
    path: '/inscricao/:event_uuid',
    name: 'eventRegister',
    component: EventRegister
  },
  {
    path: '/inscricao-sucesso',
    name: 'eventThanks',
    component: EventRegisterSuccess
  },
  {
    path: '/validar/:code',
    name: 'certificateValidation',
    component: CertificateValidation
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
})

const openRoutes = ['login', 'surveyByDispatch', 'thanks', 'eventRegister', 'eventThanks', 'certificateValidation'];

router.beforeEach((to, from, next) => {
  if (!openRoutes.includes(to.name) && !AuthService.isAuthenticated()) {
      next({ name: 'login' });
  } else {
      next();
  }
});

export default router;
